import { DomPortal } from '@angular/cdk/portal';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MapService } from '../../services/map.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
	selector: 'app-drop-pin',
	templateUrl: './drop-pin.html',
	styleUrls: ['./drop-pin.scss']
})

export class DropPinModalComponent implements OnInit, OnDestroy {
	public droppedPinLocation: any;
	public mapPortal: DomPortal<any>;
	public type: string;

	constructor(public dialogRef: MatDialogRef<DropPinModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _mapService: MapService,
				private _spinnerService: SpinnerService) {
		this.type = this.data.type;
	}

	centerOnCurrentLocation() {
		if (navigator.geolocation) {
			this._spinnerService.startSpinner();
			navigator.geolocation.getCurrentPosition((position) => {
				this._spinnerService.stopSpinner();
				const pos = {
					lat: position.coords.latitude,
					lon: position.coords.longitude
				};
				this._mapService.markerUpdated$.next({address: pos, type: 'ORIGIN', draggable: true, options: {fullscreenControl: false}});
			}, () => {
				this._spinnerService.stopSpinner();
				const pos = {
					lat: 39.8285013,
					lon: -98.5794589
				};
				this._mapService.markerUpdated$.next({address: pos, type: 'ORIGIN', draggable: true, options: {fullscreenControl: false}, zoom: 4});
			}, {enableHighAccuracy: true, timeout: 60000, maximumAge: 300000});
		} else {
			const pos = {
				lat: 39.8285013,
				lon: -98.5794589
			};
			this._mapService.markerUpdated$.next({address: pos, type: 'ORIGIN', draggable: true, options: {fullscreenControl: false, zoom: 4}});
		}
	}

	close(response) {
		this.dialogRef.close(response);
	}

	ngOnDestroy(): void {
		this._mapService.markerUpdated$.next({address: null, type: 'ORIGIN'});
	}

	ngOnInit() {
		this.mapPortal = new DomPortal(document?.getElementById('mapPortalContent'));
		// Clear out any markers
		this._mapService.markerUpdated$.next({address: null, type: 'ORIGIN'});
		this._mapService.markerUpdated$.next({address: null, type: 'DESTINATION'});
		this._mapService.markerLocationChanged$.subscribe((location) => {
			this.droppedPinLocation = location;
		})
		setTimeout(() => {
			this.centerOnCurrentLocation();
		});
	}

	processLocation() {
		const response = {
			address: this.droppedPinLocation,
			type: this.type
		};
		this.close(response);
	}
}
